import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var Withdraw = createPlugin({
    protocol: 'RADIANTV2',
    type: 'ACTION',
    method: 'withdraw',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                    amount: new FctValue({ destination: 'wei_amount' }),
                    to: new FctAddress({}),
                },
            },
            output: {
                value: new FctValue({ innerIndex: 0 }),
            },
        });
    },
});
